/** 汎用的なタブアイテムの型 */
export type TabItem<T = string> = {
  /** タブのキー（識別子） */
  value: T;
  /** タブの表示ラベル */
  label: string;
};

/** Tabコンポーネントのprops */
type TabsProps<T = string> = {
  /** タブの一覧 */
  tabs: TabItem<T>[];
  /** 選択されているタブの値 */
  selectedTabValue: T;
  /** タブを選択したときのコールバック */
  onClick: (tabKey: T) => void;
  /** 追加のCSSクラス */
  className?: string;
};

/** 汎用的なTabコンポーネント */
export const Tab = <T extends string = string>({
  tabs,
  selectedTabValue,
  onClick,
  className = '',
}: TabsProps<T>) => {
  return (
    <div className={`border-y border-outline bg-surface ${className}`}>
      <nav className="flex overflow-x-auto hidden-scrollbar" aria-label="Tabs">
        {tabs.map(tab => (
          <button
            key={tab.value}
            type="button"
            className={`
                shrink-0 border-b-2 px-[16px] py-[14px] noto-sans-jp-medium text-[14px]
                ${
                  selectedTabValue === tab.value
                    ? 'border-primary text-primary'
                    : 'border-transparent text-textSecondary hover:text-textPrimary'
                }
              `}
            onClick={() => onClick(tab.value)}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
};
